import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UserIcon from 'react-material-icons/icons/social/person';
import PlaceIcon from 'react-material-icons/icons/maps/place';
import GiftIcon from 'react-material-icons/icons/action/card-giftcard';
import CancelIcon from 'react-material-icons/icons/navigation/cancel';
import Tooltip from '../Tooltip';
import MapThumbBtn from '../MapThumbBtn';
import IconTextInfo from '../IconTextInfo';
import OrderPriceOverview from '../OrderPriceOverview';
import './index.css';

const propTypes = {
  details: PropTypes.object.isRequired,
  dealer: PropTypes.object.isRequired,
  onCloseBtnClick: PropTypes.func.isRequired,
  analyticsTrack: PropTypes.func.isRequired,
};

class HistoryOrderDetails extends Component {
  render() {
    const { details, dealer, onCloseBtnClick, analyticsTrack } = this.props;
    const markers = [
      { lat: details.lat, lng: details.lon },
      { lat: dealer.lat, lng: dealer.lon, type: 'chama' },
    ];
    const displayInfo = info => {
      if (info) {
        return info;
      }

      return <FormattedMessage id="general.missing_information" defaultMessage="Not informed" />;
    };

    return (
      <div className="HistoryOrderDetails">
        <div className="HistoryOrderDetails__row">
          <div className="HistoryOrderDetails__col">
            <div>
              <div className="HistoryOrderDetails__row">
                <IconTextInfo Icon={UserIcon}>
                  <span>{displayInfo(details.customerName)}</span>
                </IconTextInfo>
              </div>
              <div className="HistoryOrderDetails__row">
                <IconTextInfo Icon={PlaceIcon}>
                  <span>{displayInfo(details.address)}</span>
                </IconTextInfo>
              </div>
            </div>
          </div>
          <div className="HistoryOrderDetails__col HistoryOrderDetails__col--map">
            <div>
              <Tooltip position="left" title="Fechar">
                <CancelIcon
                  role="button"
                  onClick={onCloseBtnClick}
                  className="HistoryOrderDetails__close_btn"
                />
              </Tooltip>
            </div>
            <div className="HistoryOrderDetails__map_btn_wrapper">
              <MapThumbBtn
                orderLat={details.lat}
                orderLon={details.lon}
                markers={markers}
                onClick={() =>
                  analyticsTrack('OrderHistoryMapClicked', {
                    orderId: details.id,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="HistoryOrderDetails__row">
          <div>
            {details.voucher && (
              <div className="HistoryOrderDetails__voucher">
                <div className="HistoryOrderDetails__col HistoryOrderDetails__col--centered">
                  <IconTextInfo Icon={GiftIcon} iconFullOpacity>
                    <strong className="HistoryOrderDetails__voucher_text">
                      <FormattedMessage
                        id="order_details_voucher_message"
                        defaultMessage="Discount code used. Chama will pay you back."
                      />
                    </strong>
                  </IconTextInfo>
                </div>
              </div>
            )}
            <div className="HistoryOrderDetails__price_overview_wrapper">
              <OrderPriceOverview order={details} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HistoryOrderDetails.propTypes = propTypes;

export default HistoryOrderDetails;



// WEBPACK FOOTER //
// ../ui-components/components/HistoryOrderDetails/index.jsx